/* Belly Beans PDP (Winks layout). No dependencies. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Gallery: thumbnails swap the main image. */
  $$('[data-bbw-gallery]').forEach(function (g) {
    var mains = $$('[data-bbw-slide]', g), thumbs = $$('[data-bbw-thumb]', g);
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        mains.forEach(function (m, j) { m.hidden = j !== i; });
        thumbs.forEach(function (x, j) { x.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      });
    });
  });

  /* Offer cards behave as a radio group and drive the add-to-cart button. */
  $$('[data-bbw-buy]').forEach(function (box) {
    var cards = $$('[data-bbw-offer]', box);
    var btn = $('[data-bbw-atc]', box);
    var err = $('[data-bbw-err]', box);
    function select(card) {
      cards.forEach(function (c) {
        var on = c === card;
        c.setAttribute('aria-checked', on ? 'true' : 'false');
        c.tabIndex = on ? 0 : -1;
      });
      if (btn && card.dataset.atcLabel) btn.textContent = card.dataset.atcLabel;
    }
    cards.forEach(function (c, i) {
      c.addEventListener('click', function () { select(c); });
      c.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowDown' || k === 'ArrowRight') n = cards[(i + 1) % cards.length];
        if (k === 'ArrowUp' || k === 'ArrowLeft') n = cards[(i - 1 + cards.length) % cards.length];
        if (k === ' ' || k === 'Enter') { e.preventDefault(); select(c); }
        if (n) { e.preventDefault(); select(n); n.focus(); }
      });
    });
    if (!btn) return;
    /* A plain button, never a form[action="/cart/add"] submit: Shopify's web-pixel layer
       publishes product_added_to_cart for that form AND for the fetch, which double counts
       AddToCart in Meta (measured on gruns-landing 2026-07-30). The fetch alone fires it once. */
    btn.addEventListener('click', function () {
      var card = $('[data-bbw-offer][aria-checked="true"]', box) || cards[0];
      if (!card) return;
      if (card.hasAttribute('data-demo')) {  /* preview prices: no variant behind them yet */
        if (err) { err.textContent = 'Preview only. Checkout is wired once these prices exist in Shopify.'; err.style.display = 'block'; }
        return;
      }
      var label = btn.textContent;
      var item = { id: parseInt(card.dataset.variant, 10), quantity: 1 };
      if (card.dataset.plan) item.selling_plan = parseInt(card.dataset.plan, 10);
      btn.disabled = true; btn.textContent = 'Adding...';
      if (err) err.style.display = 'none';
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [item] })
          });
        })
        .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
        .then(function () { btn.textContent = 'Taking you to checkout...'; window.location.href = '/checkout'; })
        .catch(function () {
          btn.disabled = false; btn.textContent = label;
          if (err) err.style.display = 'block';
        });
    });
  });

  /* Tabs */
  $$('[data-bbw-tabs]').forEach(function (wrap) {
    var tabs = $$('[role="tab"]', wrap);
    function show(t) {
      tabs.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        var p = document.getElementById(x.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(t); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (n) { e.preventDefault(); show(n); n.focus(); }
      });
    });
  });

  /* Accordions (FAQ, tab FAQs, tab reviews, ingredient rows) */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-bbw-acc-q]');
    if (!q) return;
    var item = q.closest('[data-bbw-acc]');
    var open = item.hasAttribute('data-open');
    if (open) item.removeAttribute('data-open'); else item.setAttribute('data-open', '');
    q.setAttribute('aria-expanded', open ? 'false' : 'true');
  });

  /* Review card ages ("3w", "2mo") computed from the real review date so they never go stale. */
  $$('[data-bbw-ago]').forEach(function (el) {
    var d = Date.parse(el.getAttribute('data-bbw-ago') + 'T12:00:00Z');
    if (isNaN(d)) return;
    var days = Math.max(1, Math.floor((Date.now() - d) / 864e5));
    el.textContent = days < 7 ? days + 'd' : days < 60 ? Math.floor(days / 7) + 'w' : days < 365 ? Math.floor(days / 30) + 'mo' : Math.floor(days / 365) + 'y';
  });

  /* Customer reviews: search, sort, pagination over the rendered rows. */
  $$('[data-bbw-reviews]').forEach(function (root) {
    var rows = $$('[data-bbw-review]', root);
    var list = $('[data-bbw-review-list]', root);
    var pager = $('[data-bbw-pager]', root);
    var empty = $('[data-bbw-empty]', root);
    var search = $('[data-bbw-search]', root);
    var sort = $('[data-bbw-sort]', root);
    var per = parseInt(root.dataset.perPage || '4', 10);
    var page = 1;
    function visible() {
      var q = (search && search.value || '').trim().toLowerCase();
      var v = rows.filter(function (r) { return !q || r.textContent.toLowerCase().indexOf(q) !== -1; });
      var mode = sort ? sort.value : 'recent';
      v.sort(function (a, b) {
        if (mode === 'oldest') return a.dataset.ts - b.dataset.ts;
        if (mode === 'longest') return b.dataset.len - a.dataset.len;
        return b.dataset.ts - a.dataset.ts;
      });
      return v;
    }
    function btn(label, n, opts) {
      var b = document.createElement('button');
      b.type = 'button'; b.innerHTML = label;
      if (opts && opts.aria) b.setAttribute('aria-label', opts.aria);
      if (n === page && !(opts && opts.nav)) b.setAttribute('aria-current', 'true');
      if (opts && opts.disabled) b.disabled = true;
      b.addEventListener('click', function () { page = n; render(true); });
      return b;
    }
    function render(scroll) {
      var v = visible();
      var pages = Math.max(1, Math.ceil(v.length / per));
      if (page > pages) page = pages;
      rows.forEach(function (r) { r.hidden = true; });
      v.forEach(function (r, i) {
        list.appendChild(r);
        r.hidden = !(i >= (page - 1) * per && i < page * per);
      });
      if (empty) empty.style.display = v.length ? 'none' : 'block';
      pager.innerHTML = '';
      if (pages > 1) {
        pager.appendChild(btn('&#8249;', page - 1, { nav: true, aria: 'Previous page', disabled: page === 1 }));
        for (var n = 1; n <= pages; n++) pager.appendChild(btn(String(n), n));
        pager.appendChild(btn('&#8250;', page + 1, { nav: true, aria: 'Next page', disabled: page === pages }));
      }
      if (scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    if (search) search.addEventListener('input', function () { page = 1; render(false); });
    if (sort) sort.addEventListener('change', function () { page = 1; render(false); });
    render(false);
  });
})();
